<template>
  <div class="header-video" v-if="heroVideo">
    <video :src="heroVideo" autoplay loop muted playsinline></video>
  </div>
</template>

<script>
import { getThemeAsset, themeState } from "@/themes";

export default {
  name: "ThemeHeroVideo",
  data() {
    return {
      themeState
    };
  },
  computed: {
    heroVideo() {
      return this.themeState.activeTheme && getThemeAsset("heroVideo");
    }
  }
};
</script>
